import { BaseExportService } from "./BaseExportService";

export class IdLivenessExportService extends BaseExportService {
  constructor(data, metadata = {}) {
    super(data, metadata);
  }

  get_filename_prefix() {
    return `ID_Liveness_Report_${this.data?.IdNumber || "Unknown"}`;
  }

  get_available_sections() {
    return {
      liveness_results: "Liveness Results",
      verification_results: "Verification Results",
      personal_details: "Personal Details",
      raw_json: "Raw JSON Data",
    };
  }

  get_default_export_options() {
    return {
      liveness_results: true,
      verification_results: true,
      personal_details: true,
      raw_json: false,
    };
  }

  prepare_export_data(export_options) {
    const export_data = {};

    if (export_options.liveness_results) {
      export_data.liveness_results = this.prepare_liveness_results();
    }

    if (export_options.verification_results) {
      export_data.verification_results = this.prepare_verification_results();
    }

    if (export_options.personal_details) {
      export_data.personal_details = this.prepare_personal_details();
    }

    if (export_options.raw_json) {
      export_data.raw_json = [this.data];
    }

    return export_data;
  }

  prepare_liveness_results() {
    const liveness = this.data?.LivenessResult || {};
    return [
      {
        "Liveness Passed": liveness.LivenessPassResult ? "Yes" : "No",
        Score: liveness.LivenessResultScore,
        Probability: liveness.LivenessResultProbability,
        Quality: liveness.LivenessResultQuality,
        Message: liveness.LivenessMessage,
      },
    ];
  }

  prepare_verification_results() {
    const face_result = this.data?.FaceResult || {};
    return [
      {
        Status: this.data?.Status,
        Message: this.data?.Message,
        "First Name Matches": this.data?.FirstNameResult,
        "Last Name Matches": this.data?.LastNameResult,
        "Face Match": face_result.isIdentical ? "Yes" : "No",
        "Face Match Confidence": face_result.confidence,
        Deceased: this.data?.DeadIndicator ? "Yes" : "No",
        "ID Blocked": this.data?.IDBlocked ? "Yes" : "No",
      },
    ];
  }

  prepare_personal_details() {
    return [
      {
        "First Name": this.data?.FirstName,
        "Last Name": this.data?.LastName,
        "ID Number": this.data?.IdNumber,
        "Marital Status": this.data?.MaritalStatus,
        "Country of Birth": this.data?.BirthPlaceCountry,
      },
    ];
  }
}
